import React from "react";
import {css, Theme} from "@emotion/react";

import {flex, mr, pb, pt} from "@pg-design/helpers-css";
import {BrandLaurelIcon, BrandRankingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {IRanking} from "../../../actions/fetch_vendor_detail_rankings";

interface IProps {
    ranking: IRanking;
    linkToRanking: string;
}

const getRomanNumerals = (number: number) => {
    switch (number) {
        case 1:
            return "I";
        case 2:
            return "II";
        case 3:
            return "III";
        case 4:
            return "IV";
        default:
            return undefined;
    }
};

export const VendorDetailRankingBox: React.FC<IProps> = ({ranking, linkToRanking}) => {
    const coverSrc = ranking.offer.main_image.m_img_760x428;
    const coverAlt = ranking.offer.name;

    return (
        <a href={linkToRanking} css={linkStyle}>
            <ResponsiveCard cover={<ResponsiveCard.ImgCover alt={coverAlt} src={coverSrc} />} coverDesktopPosition="right">
                <ResponsiveCard.BodyWithIcon
                    icon={BrandRankingIcon}
                    iconText={`${getRomanNumerals(ranking.position)} miejsce`}
                    header={`${getRomanNumerals(ranking.quarter)} kwartał ${ranking.year}`}
                    headerTag="div"
                    text={ranking.region.name}
                >
                    <div css={[flex()]}>
                        <div css={laureIconHolder}>
                            <BrandLaurelIcon size="4" />
                        </div>
                        <Text variant="body_copy_2" css={[offerNameWrapper]}>
                            {ranking.offer.name}
                        </Text>
                    </div>
                </ResponsiveCard.BodyWithIcon>
            </ResponsiveCard>
        </a>
    );
};

const laureIconHolder = css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    height: 3.2rem;
    width: 3.2rem;
    ${mr(1)};
`;

const offerNameWrapper = (theme: Theme) => css`
    ${pt(0.5)};
    ${pb(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${pb(0)};
    }
`;

const linkStyle = (theme: Theme) => css`
    display: block;

    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {flex, mr, pb, pt} from "@pg-design/helpers-css";
import {BrandLaurelIcon, BrandRankingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {IRanking} from "../../../actions/fetch_vendor_detail_rankings";

interface IProps {
    ranking: IRanking;
    linkToRanking: string;
}

const getRomanNumerals = (number: number) => {
    switch (number) {
        case 1:
            return "I";
        case 2:
            return "II";
        case 3:
            return "III";
        case 4:
            return "IV";
        default:
            return undefined;
    }
};

export const VendorDetailRankingBox: React.FC<IProps> = ({ranking, linkToRanking}) => {
    const coverSrc = ranking.offer.main_image.m_img_760x428;
    const coverAlt = ranking.offer.name;

    return (
        <a href={linkToRanking} css={linkStyle}>
            <ResponsiveCard cover={<ResponsiveCard.ImgCover alt={coverAlt} src={coverSrc} />} coverDesktopPosition="right">
                <ResponsiveCard.BodyWithIcon
                    icon={BrandRankingIcon}
                    iconText={`${getRomanNumerals(ranking.position)} miejsce`}
                    header={`${getRomanNumerals(ranking.quarter)} kwartał ${ranking.year}`}
                    headerTag="div"
                    text={ranking.region.name}
                >
                    <div css={[flex()]}>
                        <div css={laureIconHolder}>
                            <BrandLaurelIcon size="4" />
                        </div>
                        <Text variant="body_copy_2" css={[offerNameWrapper]}>
                            {ranking.offer.name}
                        </Text>
                    </div>
                </ResponsiveCard.BodyWithIcon>
            </ResponsiveCard>
        </a>
    );
};

const laureIconHolder = css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    height: 3.2rem;
    width: 3.2rem;
    ${mr(1)};
`;

const offerNameWrapper = (theme: Theme) => css`
    ${pt(0.5)};
    ${pb(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${pb(0)};
    }
`;

const linkStyle = (theme: Theme) => css`
    display: block;

    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;
